import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "product-box__segment-header__wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "product-box__highlight-article-badge"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "product-box__segment-header" }
const _hoisted_7 = { class: "product-box__name" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["aria-label"]

import {computed} from 'vue';
  import type ProductBoxData from '../../../bps/types/ProductBoxData';
  import {t} from '../../../bps/utilities/js/translations/translations';
  import useHighlightArticle from '@/bps/utilities/composables/productHighlightArticle';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ProductBoxSegmentHeader',
  props: {
    productBoxData: {},
    state: {},
    numberOfBottlesInSet: { default: null },
    productLink: { default: '' },
    showReview: { type: Boolean, default: false },
    showInBasket: { type: Boolean, default: false },
    isWishlistEnabled: { type: Boolean, default: true }
  },
  emits: ['wishlistClicked'],
  setup(__props: any, { emit: __emit }) {

  const emit = __emit;

  const props = __props;

  const personalizedBannerLink = computed(() => {
    return t(`productbox.link.${props.productBoxData.personalPreferenceMessageKey}`, [props.productBoxData.url]);
  });

  const {highlightArticleData} = useHighlightArticle(props.productBoxData.highlightArticleId);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(highlightArticleData))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_unref(highlightArticleData).text)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: _unref(highlightArticleData).text,
                class: "product-box__highlight-article-text"
              }, null, 8 /* PROPS */, _hoisted_3))
            : _createCommentVNode("v-if", true),
          _cache[1] || (_cache[1] = _createTextVNode()),
          (_unref(highlightArticleData).icon)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                class: "product-box__highlight-article-icon",
                src: _unref(highlightArticleData).icon,
                alt: "",
                width: "20",
                height: "20",
                "aria-hidden": "true"
              }, null, 8 /* PROPS */, _hoisted_4))
            : _createCommentVNode("v-if", true)
        ]))
      : (_ctx.productBoxData.personalPreferenceMessageKey && !_ctx.showReview)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(personalizedBannerLink.value ? 'a' : 'div'), {
            key: 1,
            class: "product-box__personalization-banner-wrapper",
            href: personalizedBannerLink.value
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "product-box__personalization-banner personalization-banner",
                innerHTML: _unref(t)(_ctx.productBoxData.personalPreferenceMessageKey)
              }, null, 8 /* PROPS */, _hoisted_5)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["href"]))
        : _createCommentVNode("v-if", true),
    _cache[4] || (_cache[4] = _createTextVNode()),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.productLink ? 'a' : 'div'), {
        href: _ctx.productLink,
        class: "product-box__header-text"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_7, [
            (_ctx.numberOfBottlesInSet)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.numberOfBottlesInSet) + " x\n          ", 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createTextVNode(" " + _toDisplayString(_ctx.productBoxData.name), 1 /* TEXT */)
          ]),
          _cache[2] || (_cache[2] = _createTextVNode()),
          (_ctx.productBoxData.shortDescription)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "product-box__short-description",
                innerHTML: _ctx.productBoxData.shortDescription
              }, null, 8 /* PROPS */, _hoisted_9))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["href"])),
      _cache[3] || (_cache[3] = _createTextVNode()),
      (!_ctx.productBoxData.zeroPriceItem)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: _normalizeClass(["product-box__button-wishlist", {
          'product-box__button-wishlist--filled': _ctx.isWishlistEnabled && _ctx.productBoxData.inWishlist,
          'product-box__button-wishlist--remove': !_ctx.isWishlistEnabled,
          'product-box__button-wishlist--loading': _ctx.state === 'loadingWishlist',
        }]),
            "aria-label": _unref(t)('wishlist.default.name'),
            type: "button",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('wishlistClicked')), ["prevent"]))
          }, null, 10 /* CLASS, PROPS */, _hoisted_10))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}
}

})